import { Badge, Card, Group, Image, Table, Text } from '@mantine/core';

const formatPrice = (value, currency) => {
  if (value === undefined || value === null) {
    return '—';
  }
  return currency ? `${value} ${currency}` : `${value}`;
};

const ProductVariantsTab = ({ variants, currency }) => {
  return (
    <Card withBorder>
      <Table.ScrollContainer minWidth={700}>
        <Table striped withTableBorder withColumnBorders highlightOnHover verticalSpacing="sm">
          <Table.Thead>
            <Table.Tr>
              <Table.Th />
              <Table.Th>Variant ID</Table.Th>
              <Table.Th>SKU</Table.Th>
              <Table.Th>Options</Table.Th>
              <Table.Th>List price</Table.Th>
              <Table.Th>Discount price</Table.Th>
              <Table.Th>Stock</Table.Th>
              <Table.Th>Barcode</Table.Th>
              <Table.Th>Availability</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {variants.map((variant, index) => (
              <Table.Tr key={variant.variantId ?? index}>
                <Table.Td>
                  {variant.imageUrl ? (
                    <Image
                      src={variant.imageUrl}
                      alt={variant.variantId}
                      referrerPolicy="no-referrer"
                      fit="contain"
                      w={48}
                      h={48}
                    />
                  ) : (
                    <Text size="xs" c="dimmed">
                      —
                    </Text>
                  )}
                </Table.Td>
                <Table.Td>
                  <Text size="sm">{variant.variantId ?? '—'}</Text>
                </Table.Td>
                <Table.Td>
                  <Text size="sm">{variant.sku ?? '—'}</Text>
                </Table.Td>
                <Table.Td>
                  {variant.optionValues?.length ? (
                    <Group gap={4}>
                      {variant.optionValues.map((option, i) => (
                        <Badge key={i} variant="light" color="gray" size="sm">
                          {option.name}: {option.value}
                        </Badge>
                      ))}
                    </Group>
                  ) : (
                    <Text size="xs" c="dimmed">
                      —
                    </Text>
                  )}
                </Table.Td>
                <Table.Td>
                  <Text size="sm">{formatPrice(variant.listPrice, currency)}</Text>
                </Table.Td>
                <Table.Td>
                  <Text size="sm">{formatPrice(variant.discountPrice, currency)}</Text>
                </Table.Td>
                <Table.Td>
                  <Text size="sm">{variant.stockQuantity ?? '—'}</Text>
                </Table.Td>
                <Table.Td>
                  <Text size="sm">{variant.barcode ?? '—'}</Text>
                </Table.Td>
                <Table.Td>
                  {variant.available ? (
                    <Badge color="green" variant="light" size="sm">
                      In stock
                    </Badge>
                  ) : (
                    <Badge color="red" variant="light" size="sm">
                      Out of stock
                    </Badge>
                  )}
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
    </Card>
  );
};

export default ProductVariantsTab;
